import {
  fetchSavedCards as fetchSavedCardsFromApi,
  postRecurringPayment,
  fetchRecurringPayment,
  deletePaymentMethod as deletePaymentMethodAtAPI,
  setPaymentMethodAsPrimary as setPaymentMethodAsPrimaryAtAPI,
  fetchAutoTopUps as fetchAutoTopUpsFromAPI,
  removeAutoTopUp as removeAutoTopUpAtAPI,
  setAutoTopUp as setAutoTopUpAtAPI,
  setPaymentData as submit3DSecureDataLegacy
} from '@/api/order'
import { hasToExecute3DSecure, execute3DSecure } from '@/utils/adyen'
import { objectHasKeys } from '@/utils/comparators'

const fetchSavedCards = async ({ commit }) => {
  let response = await fetchSavedCardsFromApi()
  commit('SET_CARDS', response)
}

const loadSavedCards = async ({ dispatch, state }) => {
  if (!objectHasKeys(state.cards)) {
    await dispatch('fetchSavedCards')
  }
}

const savePaymentMethod = async ({ commit, state, dispatch }, data) => {
  commit('SAVE_PAYMENT_METHOD_SUBMIT')
  try {
    let response = await postRecurringPayment(data)
    if (response.status && response.status.state === 'failed') {
      if (response.message) {
        commit('SAVE_PAYMENT_METHOD_ERROR', response.message)
        throw Error(response.message)
      } else {
        commit('SAVE_PAYMENT_METHOD_ERROR')
        throw Error('Unkwnown error')
      }
    } else {
      commit('SAVE_PAYMENT_METHOD_SET_ORDER_ID', response.id)

      if (hasToExecute3DSecure(response.providerData)) {
        commit('SAVE_PAYMENT_METHOD_SET_STATE', '3D_SECURITY_CHECK')
        execute3DSecure(JSON.parse(response.providerData))
      } else {
        dispatch('getSavePaymentMethodState', response.id)
      }
      return response
    }
  } catch (error) {
    commit('SAVE_PAYMENT_METHOD_ERROR', error)
    throw error
  }
}

const getSavePaymentMethodState = async ({ commit, state, dispatch }, orderId) => {
  commit('GET_SAVE_PAYMENT_METHOD_STATE_CHECK_COUNTER_INCREASE')
  try {
    const response = await fetchRecurringPayment(orderId)
    if (!response.errors) {
      if (response.providerData && !state.savePaymentMethod3DSChallange) {
        let providerData = JSON.parse(response.providerData)
        if (providerData.sdk) {
          commit('SAVE_PAYMENT_METHOD_SET_STATE', '3D_SECURITY_CHECK')
          commit('SAVE_PAYMENT_METHOD_3D_SECURE_CHALLANGE', providerData)
        } else {
          commit('SAVE_PAYMENT_METHOD_SET_STATE', '3D_SECURITY_CHECK_LEGACY')
          execute3DSecure(providerData)
        }
      } else if (response.status.state === 'pending') {
        commit('SAVE_PAYMENT_METHOD_SET_STATE', 'IN_PROGRESS')
        if (state.savePaymentMethodStateCheckCounter < 30) {
          await new Promise(resolve => setTimeout(resolve, 3000))
          dispatch('getSavePaymentMethodState', orderId)
        } else {
          commit('SAVE_PAYMENT_METHOD_TIMEOUT')
        }
      } else if (response.status.state === 'success') {
        commit('SAVE_PAYMENT_METHOD_SUCCESS', response)
      } else if (response.status.state === 'failed') {
        commit('SAVE_PAYMENT_METHOD_ERROR', response.message)
      }
    } else {
      throw response.errors
    }
  } catch (error) {
    commit('SAVE_PAYMENT_METHOD_ERROR', error)
    throw error
  }
}

const deletePaymentMethod = async ({ commit }, pid) => {
  return new Promise((resolve, reject) => {
    commit('EDIT_PAYMENT_METHOD_SUBMIT')

    deletePaymentMethodAtAPI(pid)
      .then((response) => {
        if (!response) {
          commit('EDIT_PAYMENT_METHOD_SUCCESS')
          resolve()
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('EDIT_PAYMENT_METHOD_ERROR')
        reject(error)
      })
  })
}

const setPaymentMethodAsPrimary = async ({ commit }, pid) => {
  return new Promise((resolve, reject) => {
    commit('EDIT_PAYMENT_METHOD_SUBMIT')

    setPaymentMethodAsPrimaryAtAPI(pid)
      .then((response) => {
        if (response.status === 204) {
          commit('EDIT_PAYMENT_METHOD_SUCCESS')
          resolve()
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('EDIT_PAYMENT_METHOD_ERROR')
        reject(error)
      })
  })
}

const submit3DSecureData = async ({ commit, state, dispatch }, providerData) => {
  // commit('SUBMIT_3D_SECURE_DATA')
  try {
    const response = await submit3DSecureDataLegacy({
      providerData: providerData,
      recurringDetailId: state.savePaymentMethodOrderId
    })
    if (!response.errors) {
      commit('SET_WAITING_AFTER_3DS_CHALLANGE', true)
      dispatch('getSavePaymentMethodState', state.savePaymentMethodOrderId)
    } else {
      throw response.errors
    }
  } catch (result) {
    result.type = 'SUBMIT_3D_SECURE_DATA'
    dispatch('handleError', result)
    throw result
  }
}

const savePaymentMethodReset = async ({ commit }) => {
  commit('SAVE_PAYMENT_METHOD_RESET')
}

const setSavePaymentMethodState = async ({ commit }, state) => {
  commit('SAVE_PAYMENT_METHOD_SET_STATE', state)
}

const setEditPaymentMethodState = async ({ commit }, state) => {
  commit('EDIT_PAYMENT_METHOD_SET_STATE', state)
}

const fetchAutoTopUps = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('GET_AUTO_TOP_UPS_SUBMIT')

    fetchAutoTopUpsFromAPI()
      .then((response) => {
        if (response) {
          commit('GET_AUTO_TOP_UPS_SUCCESS', response)
          resolve()
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('GET_AUTO_TOP_UPS_ERROR')
        reject(error)
      })
  })
}

const setAutoTopUp = async ({ commit }, productId) => {
  return new Promise((resolve, reject) => {
    commit('SET_AUTO_TOP_UP_SUBMIT')

    setAutoTopUpAtAPI(productId)
      .then((response) => {
        if (!response) {
          commit('SET_AUTO_TOP_UP_SUCCESS')
          resolve()
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('SET_AUTO_TOP_UP_ERROR')
        reject(error)
      })
  })
}

const removeAutoTopUp = async ({ commit }, productId) => {
  return new Promise((resolve, reject) => {
    commit('SET_AUTO_TOP_UP_SUBMIT')

    removeAutoTopUpAtAPI(productId)
      .then((response) => {
        if (!response) {
          commit('SET_AUTO_TOP_UP_SUCCESS')
          resolve()
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('SET_AUTO_TOP_UP_ERROR')
        reject(error)
      })
  })
}

export default {
  fetchSavedCards,
  loadSavedCards,
  savePaymentMethod,
  getSavePaymentMethodState,
  setSavePaymentMethodState,
  submit3DSecureData,
  deletePaymentMethod,
  fetchAutoTopUps,
  setAutoTopUp,
  removeAutoTopUp,
  setPaymentMethodAsPrimary,
  savePaymentMethodReset,
  setEditPaymentMethodState
}



// WEBPACK FOOTER //
// ./src/store/modules/user/wallet/actions.js